import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bulk-petition-tags',
		path: '/dashboard/bulk_petition_tags',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_bulkTags" */ './index'), {
			exportName: 'BulkTags',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
